import { Box, Typography } from "@mui/material";
import Chart from "react-apexcharts";
import useColors from "../../../../api/hooks/useColors";

export default function FrameworkOverviewGauge({
  value,
  invertColorScale = false,
}) {
  const colors = useColors();

  const percentage = invertColorScale ? 100 - value : value;

  const chartOptions = {
    series: [percentage],
    colors: [colors.primary_300main],
    legend: { show: false },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}%`,
      style: {
        fontSize: "12px",
        fontFamily: "Poppins",
        fontWeight: "400",
      },
    },
    stroke: { lineCap: "round" },
    fill: { type: "solid" },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        dataLabels: {
          name: { show: false },
          value: {
            offsetY: 0,
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "500",
          },
        },
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        pb: 2,
      }}
    >
      <Typography
        variant="body2"
        color={colors.text_primary}
        sx={{ mb: -2, textAlign: "center" }}
      >
        Overall Score
      </Typography>
      <Box sx={{ width: "200px", height: "70px" }}>
        <Chart
          options={chartOptions}
          series={chartOptions.series}
          type="radialBar"
        />
      </Box>
    </Box>
  );
}
